import { Icon } from "@iconify/react";
import React from "react";
import { activityIcon, toneClass } from "../../utils/dashboardFormat";

const RecentActivityAnalytics = ({ items = [] }) => {
    const list = Array.isArray(items) ? items : [];

    return (
        <div className="col-xxl-8 col-lg-8 col-md-12">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="mb-3">
                        <h6 className="mb-1 text-lg">Recent Activity</h6>
                        <p className="mb-0 text-secondary-light text-sm">
                            Latest campaigns, templates, queue, and instance events
                        </p>
                    </div>

                    {list.length === 0 ? (
                        <div className="dash-empty">
                            <Icon icon="mdi:timeline-clock-outline" />
                            <span>No recent activity</span>
                        </div>
                    ) : (
                        list.map((activity) => (
                            <div
                                key={activity.id || `${activity.title}-${activity.timestamp || activity.time}`}
                                className="dash-activity-item"
                            >
                                <div className={`dash-activity-icon ${toneClass(activity.tone)}`}>
                                    <Icon
                                        icon={activityIcon(activity.type, activity.tone)}
                                        className="text-white text-xl"
                                    />
                                </div>
                                <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-start gap-2">
                                        <p className="dash-activity-title">{activity.title}</p>
                                        <p className="dash-activity-time">{activity.time}</p>
                                    </div>
                                    {activity.description && (
                                        <p className="dash-activity-desc">{activity.description}</p>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecentActivityAnalytics;
